import type { RouteObject } from "react-router-dom";
import InventoryList, { inventoryListLoader } from "./List";
import InventoryDetailPage, { inventoryDetailLoader } from "./Detail";
import InventoryExceptionsPage, { exceptionsLoader } from "./Exceptions";
import GoodsReceiptPage from "./Receipts";
import Adjustments, { adjustmentsLoader } from "./Adjustments";
import StockUploadList from "./uploads/List";
import StockUploadPreview, { legacyUploadLoader } from "./uploads/Preview";
import AppError from "../app-error";

/**
 * Nested under the root route's children — inherits the permission guard and AppShell, same as
 * `orders/routes.tsx`. `/inventory` and `/inventory/exceptions` are gated by `inventory.read`;
 * `/inventory/receipts`, `/inventory/adjustments` and `/inventory/uploads` (US4/T021-T023) are all
 * gated by `inventory.administer` — the backend's real `[Authorize]` codes (`InventoryController.cs`),
 * not the invented `stock.*` vocabulary the placeholder contract used (`nav.tsx`,
 * `root.tsx`'s `permissionForPath`). `/inventory/exceptions`, `/inventory/adjustments` and
 * `/inventory/uploads` are listed before the `:skuSlug` catch-all so none is shadowed by it.
 */
export const inventoryRoutes: RouteObject[] = [
  { path: "inventory", Component: InventoryList, loader: inventoryListLoader, errorElement: <AppError /> },
  { path: "inventory/exceptions", Component: InventoryExceptionsPage, loader: exceptionsLoader, errorElement: <AppError /> },
  { path: "inventory/receipts", Component: GoodsReceiptPage, errorElement: <AppError /> },
  { path: "inventory/adjustments", Component: Adjustments, loader: adjustmentsLoader, errorElement: <AppError /> },
  { path: "inventory/uploads", Component: StockUploadList, errorElement: <AppError /> },
  { path: "inventory/uploads/preview", Component: StockUploadPreview, errorElement: <AppError /> },
  // The preview's address before it had its own; a bookmarked id lands on the pending upload.
  { path: "inventory/uploads/:uploadId", loader: legacyUploadLoader, errorElement: <AppError /> },
  { path: "inventory/:skuSlug", Component: InventoryDetailPage, loader: inventoryDetailLoader, errorElement: <AppError /> },
];
